import { Component, OnInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { NotificationService } from 'src/app/shared/Notification.service';
@Component({
  selector: 'app-confirm-otp',
  templateUrl: './confirm-otp.component.html',
  styleUrls: ['./confirm-otp.component.css']
})
export class ConfirmOtpComponent implements OnInit {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  
  otpForm: FormGroup;
  isLoading = false;
  timeLeft = 180; // 3 phút
  otpControls = new Array(6); // 6 ô input cho OTP
  timerInterval: any;

  constructor(
    private fb: FormBuilder,
    public ThanhVienService: ThanhVienService,
    private NotificationService: NotificationService,
    private dialogRef: MatDialogRef<ConfirmOtpComponent>
  ) {
    this.otpForm = this.createForm();
  }

  ngOnInit() {
    this.startTimer();
  }

  createForm(): FormGroup {
    const group = {};
    for (let i = 0; i < 6; i++) {
      group['digit' + i] = ['', [Validators.required, Validators.pattern('^[0-9]$')]];
    }
    return this.fb.group(group);
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  onOtpInput(event: any, index: number) {
    const input = event.target;
    const value = input.value;

    if (value.length === 1 && index < 5) {
      this.otpInputs.toArray()[index + 1].nativeElement.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && index > 0 && !this.otpForm.get('digit' + index)?.value) {
      this.otpInputs.toArray()[index - 1].nativeElement.focus();
    }
  }

  resendOTP() {
    this.ThanhVienService.SendOTPAsync().subscribe(
      res => {
      },
      err => {
      }
    );
    this.timeLeft = 180;
    this.startTimer();
  }

  confirmOTP() {
    if (this.otpForm.valid) {
      this.isLoading = true;
      const otp = Object.values(this.otpForm.value).join('');
      
      this.ThanhVienService.FormData.OTP = otp;
      this.ThanhVienService.ConfirmOTPAsync().subscribe(
        res => {
          if(res == 1){
            this.NotificationService.success('Xác thực OTP thành công');
          }else if(res == 2){
            this.NotificationService.warn('OTP đã hết hạn');
          }else if(res == 3){
            this.NotificationService.warn('OTP không đúng');
          }else{
            this.NotificationService.warn('Xác thực OTP thất bại');
          }
        },
        err => {
          this.NotificationService.warn('Xác thực OTP thất bại');
        }
      );
      // Giả lập API call
      setTimeout(() => {
        this.isLoading = false;
        this.dialogRef.close(true);
      }, 1500);
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
